module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view', {
    staticClass: "view"
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view', {
    staticClass: "view"
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09aad170"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 810
// module chunks = 1